module.exports = "/_next/static/images/gridOptimization-4ff941168b17def4492b6b3f4690ba75.png";